import React, { useState, useEffect, useCallback } from "react";
import { Form } from "react-bootstrap";
import JobInformationSection from "./JobInformationSection.js";
import SearchDropDown from "../SearchDropDown.js";

const JobTitleSection = (props) => {
  const { userCurrentJobTitle, updateUserJobTitle } = props;
  const [allJobs, setAllJobs] = useState([]);
  const [filteredJobs, setFilteredJobs] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [searchBarFocus, setSearchBarFocus] = useState(false);
  const [hasSelectedNewJob, setHasSelectedNewJob] = useState(false);

  const getJobs = useCallback(() => {
    if (props.mode === "add") {
      return props.jobs.map((job) => job.name);
    } else if (props.mode === "update") {
      return props.jobs;
    }
  }, [props.jobs, props.mode]);

  useEffect(() => {
    if (userCurrentJobTitle) {
      if (userCurrentJobTitle !== "Other") {
        setSearchQuery(userCurrentJobTitle);
        updateUserJobTitle(userCurrentJobTitle);
      } else {
        setSearchQuery("Other (Please Specify)");
        updateUserJobTitle("Other (Please Specify)");
      }
    }
  }, [userCurrentJobTitle, updateUserJobTitle]);

  useEffect(() => {
    if (props.jobs) {
      const sortedJobs = getJobs().sort((a, b) => a.localeCompare(b));
      moveToEndOfList(sortedJobs, "Other (Please Specify)");
      setAllJobs(sortedJobs);
    }
  }, [props.jobs, getJobs]);

  useEffect(() => {
    setFilteredJobs(allJobs.filter((job) => job.toLowerCase().includes(searchQuery.toLowerCase())));
  }, [searchQuery, allJobs]);

  const moveToEndOfList = (arr, item) => {
    const index = arr.indexOf(item);
    if (index > -1) {
      arr.splice(index, 1);
      arr.push(item);
    }
  };

  const onSearchBarBlur = () => {
    setSearchBarFocus(false);
    if (!allJobs.map((job) => job.toLowerCase()).includes(searchQuery.toLowerCase())) {
      setSearchQuery("");
      updateUserJobTitle("");
    } else {
      const formattedJobTitle = allJobs.find((job) => job.toLowerCase() === searchQuery.toLowerCase());
      setSearchQuery(formattedJobTitle);
      updateUserJobTitle(formattedJobTitle);
    }
  };

  const onSearchBarFocus = () => {
    setSearchBarFocus(true);
    setFilteredJobs(allJobs);
  };

  const onJobMouseDown = (job) => {
    setSearchQuery(job);
    updateUserJobTitle(job);
    setHasSelectedNewJob(true);
  };

  return (
    <div className="my-2">
      Job Title
      <Form.Group
        style={{ display: "flex", gap: "15px", border: "1px solid #929292", borderRadius: "5px", padding: "10px" }}
        controlId="jobTitle"
      >
        <div style={{ flex: "1 1 33.3%" }}>
          <SearchDropDown
            searchQuery={searchQuery}
            setSearchQuery={setSearchQuery}
            onSearchBarFocus={onSearchBarFocus}
            onSearchBarBlur={onSearchBarBlur}
            searchBarFocus={searchBarFocus}
            allInfo={allJobs}
            filteredInfo={filteredJobs}
            onInfoMouseDown={onJobMouseDown}
          />
          {props.user.jobTitle && props.user.jobTitle === "Other (Please Specify)" && (
            <div className="mt-3">
              Please Specify
              <Form.Control
                type="text"
                custom
                onChange={(value) =>
                  props.setUser((prevUser) => ({
                    ...prevUser,
                    otherJobTitle: value.target.value,
                  }))
                }
              />
            </div>
          )}
        </div>
        <div style={{ flex: "1 1 66.6%" }}>
          <JobInformationSection
            mode={props.mode}
            user={props.user}
            setUser={props.setUser}
            bundlesList={props.bundlesList}
            requestType={props.requestType}
            typeOfModal={props.typeOfModal}
            updateLocationsSupporting={props.updateLocationsSupporting}
            userLicenseBundle={props.userLicenseBundle}
            hasSelectedNewJob={hasSelectedNewJob}
          />
        </div>
      </Form.Group>
    </div>
  );
};

export default JobTitleSection;
